import React from 'react'
import { useLocation } from 'react-router-dom'
import { TOptionType } from '../../types/CustomSelect'
import { TPerPageProps } from '../../types/PerPage'
import Select from '../CustomSelect'

const PerPage = ({ onPerPageChange, perPage }: TPerPageProps) => {
  const location = useLocation()

  const isProductPage = location.pathname === '/product' || location.pathname === '/accessory'

  const perPageOption: TOptionType<number>[] = isProductPage
    ? [
      { value: 10, label: "10" },
      { value: 20, label: "20" },
      { value: 30, label: "30" },
      { value: 40, label: "40" },
      { value: 50, label: "50" },
      { value: 100, label: "100" },
      { value: 200, label: "200" },
      { value: 500, label: "500" },
    ]
    : [
      { value: 10, label: "10" },
      { value: 20, label: "20" },
      { value: 30, label: "30" },
      { value: 40, label: "40" },
    ]

  return (
    <Select
      size="small"
      label={"select"}
      value={perPageOption.find(t => t.value === perPage)}
      name="Select per page"
      onChange={(v: any) => {
        onPerPageChange && onPerPageChange(v.value)
      }}
      options={perPageOption}
    />
  )
}

export default React.memo(PerPage)



// import React from 'react'
// import { TOptionType } from '../../types/CustomSelect';
// import { TPerPageProps } from '../../types/PerPage';
// import Select from '../CustomSelect';

// const perPageOption: TOptionType<number>[] = [
//   { value: 10, label: "10" },
//   { value: 20, label: "20" },
//   { value: 30, label: "30" },
//   { value: 50, label: "50" },
//   { value: 100, label: "100" },
//   { value: 200, label: "200" },
//   { value: 500, label: "500" },
// ]


// const PerPage = ({ onPerPageChange, perPage }: TPerPageProps) => {
//   return (
//     <Select size='small'
//       label={"select"}
//       value={perPageOption.find(t => t.value === perPage)}
//       name="Select per page"
//       onChange={(v: any) => {
//         onPerPageChange && onPerPageChange(v.value)
//       }}
//       options={perPageOption} />
//   )
// }

// export default React.memo(PerPage)